import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

class ErrorDialog extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    const {t} = this.props;
    return (
      <Dialog open={this.props.isShowErrorDialog || false}>
        <DialogTitle>{t('general_error')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {this.props.errorDialogContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            if (this.props.onClick) {
              this.props.onClick();
            }
          }} color="primary" autoFocus>
            {t('general_ok')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

}

const styles = {};

export default withTranslation()(ErrorDialog);